export enum MarketSection {
  LAST_CHANCE = 'last-chance',
  HOT_DEAL = 'hot-deal',
  EARLY_BIRD = 'early-bird',
}

export type MarketSectionFilter = MarketSection | 'normal' | 'all';

export const MARKET_SECTION_LABEL: Record<MarketSection, string> = {
  [MarketSection.LAST_CHANCE]: '라스트찬스',
  [MarketSection.HOT_DEAL]: '핫딜',
  [MarketSection.EARLY_BIRD]: '얼리버드',
};

export interface MarketMetaSnapshot {
  lastChanceItemId?: string;
  sourceProductId?: string;
  sourceOptionId?: string;
  groupId?: string;
  scheduleDate?: string;
}

export interface MarketSectionProductLike {
  marketSection?: MarketSection | string;
  isLastChance?: boolean;
  isClearMarket?: boolean;
  marketMeta?: MarketMetaSnapshot & { clearMarketItemId?: string };
  clearMarketItemId?: string;
}

const LAST_CHANCE_MARKET_SECTIONS = ['last-chance', 'clear-market'] as const;

export function resolveMarketSection(product?: MarketSectionProductLike | null): MarketSection | undefined {
  if (!product) return undefined;
  if (product.marketSection && LAST_CHANCE_MARKET_SECTIONS.includes(product.marketSection as 'last-chance')) {
    return MarketSection.LAST_CHANCE;
  }
  if (product.marketSection && Object.values(MarketSection).includes(product.marketSection as MarketSection)) {
    return product.marketSection as MarketSection;
  }
  if (product.isLastChance || product.isClearMarket) {
    return MarketSection.LAST_CHANCE;
  }
  return undefined;
}

export function getMarketSectionLabel(product?: MarketSectionProductLike | null): string {
  const section = resolveMarketSection(product);
  return section ? MARKET_SECTION_LABEL[section] : '-';
}

export const MARKET_SECTION_FILTER_OPTIONS: { value: MarketSectionFilter; label: string }[] = [
  { value: 'all', label: '전체' },
  { value: MarketSection.LAST_CHANCE, label: '라스트찬스' },
  { value: MarketSection.HOT_DEAL, label: '핫딜' },
  { value: MarketSection.EARLY_BIRD, label: '얼리버드' },
  { value: 'normal', label: '일반' },
];
